
import Litecoin from "../../../assets/duotone/Litecoin.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LitecoinIcon({ className, dataTestid = "LitecoinIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Litecoin data-testid={dataTestid} className={classes} {...rest} />
  );
}
